/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Post_ContentInputs */

const en_label_post_content = /** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article Content`)
};

const es_label_post_content = /** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido del Artículo`)
};

const fr_label_post_content = /** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu de l'article`)
};

const de_label_post_content = /** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikelinhalt`)
};

const id_label_post_content = /** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten Artikel`)
};

/** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */
const ja_label_post_content = en_label_post_content;

/** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */
const zh_label_post_content = en_label_post_content;

/** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */
const ar_label_post_content = en_label_post_content;

/** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */
const it_label_post_content = en_label_post_content;

/** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */
const ru_label_post_content = en_label_post_content;

/** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */
const pt_label_post_content = en_label_post_content;

/** @type {(inputs: Label_Post_ContentInputs) => LocalizedString} */
const ko_label_post_content = en_label_post_content;

/**
* | output |
* | --- |
* | "Article Content" |
*
* @param {Label_Post_ContentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_post_content = /** @type {((inputs?: Label_Post_ContentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Post_ContentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_post_content(inputs)
	if (locale === "es") return es_label_post_content(inputs)
	if (locale === "fr") return fr_label_post_content(inputs)
	if (locale === "de") return de_label_post_content(inputs)
	if (locale === "ja") return ja_label_post_content(inputs)
	if (locale === "zh") return zh_label_post_content(inputs)
	if (locale === "ar") return ar_label_post_content(inputs)
	if (locale === "id") return id_label_post_content(inputs)
	if (locale === "it") return it_label_post_content(inputs)
	if (locale === "ru") return ru_label_post_content(inputs)
	if (locale === "pt") return pt_label_post_content(inputs)
	return ko_label_post_content(inputs)
});